import { CSSObject, styled } from 'libs/ui/styled';

export const HeaderStyled = styled('header')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,

  [theme.breakpoints.down('mobile')]: {
    gap: 12,
  } as CSSObject,

  '.formContainer-title': {
    whiteSpace: 'pre-line',

    [theme.breakpoints.down('mobile')]: {
      lineHeight: '112%',
    } as CSSObject,
  },
}));
